<template>
  <div class="zeeman-pro-fixed">
    <div class="viz-header-compact" >
      <div class="brief" v-latex="knowledgePoint"></div>
      <div class="formula-chip" v-latex>$ΔE = g · μ_B · B · m_j$</div>
    </div>

    <div class="main-layout vertical">
      <div class="simulation-stage dark-stage">
        <div class="hud-panel">
          <div class="hud-item cyan">
            <label>外磁场强度 B</label>
            <span class="val">{{ bField.toFixed(2) }} <small>Tesla</small></span>
          </div>
          <div class="hud-item orange">
            <label>能级间距 ΔE</label>
            <span class="val">{{ (bField * 5.8).toFixed(1) }} <small>μeV</small></span>
          </div>
        </div>

        <svg width="100%" height="240" viewBox="0 0 450 240" preserveAspectRatio="xMidYMid meet">
          <!-- 基态能级 (Ground Level) -->
          <line x1="50" y1="200" x2="180" y2="200" stroke="#94a3b8" stroke-width="2" />
          <text x="50" y="215" fill="#64748b" font-size="9">基态 E₁</text>

          <!-- 激发态能级 (Excited State Splitting) -->
          <g v-if="bField < 0.1">
             <line x1="50" y1="80" x2="180" y2="80" stroke="#fbbf24" stroke-width="2" />
             <text x="50" y="75" fill="#fbbf24" font-size="10">简并态 E₂</text>
          </g>
          <g v-else>
             <line x1="50" :y1="80 - bField*20" x2="180" :y2="80 - bField*20" stroke="#f43f5e" stroke-width="2" />
             <line x1="50" y1="80" x2="180" y2="80" stroke="#fbbf24" stroke-width="2" opacity="0.6" />
             <line x1="50" :y1="80 + bField*20" x2="180" :y2="80 + bField*20" stroke="#0ea5e9" stroke-width="2" />
             <text x="50" y="75" fill="#f43f5e" font-size="9">m_j = +1</text>
             <text x="50" y="95" fill="#0ea5e9" font-size="9">m_j = -1</text>
          </g>

          <!-- 模拟光谱线展示 (Spectroscopy HUD) -->
          <g transform="translate(250, 40)">
             <rect width="180" height="180" fill="#0f172a" stroke="#334155" />
             <text x="90" y="165" text-anchor="middle" fill="#64748b" font-size="10">观测光谱线分裂 (B={{bField}}T)</text>
             <line x1="90" y1="20" x2="90" y2="140" stroke="#fbbf24" stroke-width="2" />
             <line v-if="bField > 0.1" :x1="90 - bField*25" y1="20" :x2="90-bField*25" y2="140" stroke="#f43f5e" stroke-width="2" />
             <line v-if="bField > 0.1" :x1="90 + bField*25" y1="20" :x2="90+bField*25" y2="140" stroke="#0ea5e9" stroke-width="2" />
          </g>
        </svg>

        <div class="physics-caption">
           规律：在强磁场中，原子的总角动量在磁场方向上的投影量子化，导致原本合一的能级发生劈裂。
        </div>
      </div>

      <div class="compact-controls">
        <div class="control-card">
           <div class="flex-row items-center gap-6">
              <div class="flex-1">
                 <label class="s-label">调节外部超导磁体强度 (Tesla)：{{ bField.toFixed(2) }} T</label>
                 <el-slider v-model="bField" :min="0" :max="2.0" :step="0.01" size="small"></el-slider>
              </div>
              <div class="btn-group">
                 <el-button type="info" size="mini" @click="bField = 0">撤销磁场</el-button>
              </div>
           </div>
        </div>
        
        <!-- 原子专业高对比度卡片加固 -->
        <div class="discovery-card-discovery-special" v-latex>
           <div class="icon-wrap"><i class="el-icon-odometer"></i></div>
           <div class="text-content">
             <p><strong>实战物理/量子力学：</strong>塞曼效应是量子化的直接铁证。<strong>解惑：</strong>为何光谱有时会变出多条线来？<strong>观察：</strong>调节滑块。你会发现当磁场加强时，原本重叠的激发态（黄色线）分裂成了三条平行的线。这意味着原子在高磁场下产生了不同的能级路径，这一现象曾帮科学家精确测定了星系的磁场分布。
             </p>
           </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default { props: { knowledgePoint: String },
  name: 'ZeemanSplitProViz',
  data() {
    return {
      bField: 0.8
    }
  }
}
</script>

<style scoped lang="scss">
@import "./PhysicsCommon.scss";
.zeeman-pro-fixed { flex: 1; display: flex; flex-direction: column; gap: 8px; height: 100%; overflow: hidden; }
</style>
